import React, { PropTypes } from 'react';

function LowResultItem({ innerHtml }) {
  return (<div dangerouslySetInnerHTML={{ __html: innerHtml }} />);
}

LowResultItem.propTypes = {
  innerHtml: PropTypes.string,
};

export default LowResultItem;



// WEBPACK FOOTER //
// js/src/assessment/ResultItem.js